export default __webpack_public_path__ + "static/media/347.9ccdddc1.jpg";